
import { Component, Mixins, Prop } from "vue-property-decorator";

import OrderLineGroupByListing from "./OrderLineGroupByListing.vue";
import OrderListingOrdersOnly from "./OrderListingOrdersOnly.vue";

import PermissionService from "@pazion/pazion-core/src/services/permission-service";

@Component({
  components: {
    OrderListingOrdersOnly,
    OrderLineGroupByListing,
  },
})
export default class OrderListDisplayWrapper extends Mixins(PermissionService) {
  @Prop({ default: false })
  public isShapemakers!: boolean;

  private $orderListingType: string | undefined;
  private localTypeStatus: string | undefined = "order";
  public modeSwitcher: string = "order";

  get canSwitchViewMode() :boolean{
    return this.hasProfileFlag('orderManagement.list.viewSwitcher');
  }

  triggerOrderType(type: string) {
    this.localTypeStatus = type;
  }

  get isOrdersOnlyListing(): boolean {
    return this.localTypeStatus === "order";
  }

  get switcherPosition(): number {
    if (this.localTypeStatus === "order" &&
        this.canShowBatch &&
        this.canShowMulti) {
      return 580;
    }
    if (this.localTypeStatus === "order" && (this.canShowBatch || this.canShowMulti)) {
      return 410;
    }
    return 410;
  }

  changeView(state: string) {
    this.localTypeStatus = state;
  }

  get canShowBatch() {
    return this.hasProfileFlag("fulfilmentManagement.batch");
  }

  get canShowMulti() {
    return this.hasProfileFlag("fulfilmentManagement.multiOrder");
  }

  mounted() {
    this.localTypeStatus = this.$orderListingType;
    this.modeSwitcher = this.$orderListingType;
  }
}
